<email-editor
  #editor
  [options]="editorOptions"
  [minHeight]="minHeight"
  [scriptUrl]="scriptUrl"
  (loaded)="onLoaded()"
  (ready)="onReady()">
</email-editor>
